import { parseQuestionnaireAmount } from "./questionnaire"

export interface VendorPaymentSlot { vendorId: string; accountNumber: string; paymentAmount: string }
export interface VendorPaymentEntry { vendorId: number; accountNumber: string; paymentAmount: number }

export function parseLiheapVendorSlots(slots: readonly VendorPaymentSlot[]):
  { payments: VendorPaymentEntry[]; error?: never } | { error: string; payments?: never } {
  const entered = slots.filter((slot) => slot.vendorId.trim() || slot.accountNumber.trim() || slot.paymentAmount.trim())
  if (entered.length < 1 || entered.length > 2) return { error: "Enter one or two vendor payments; leave the unused slot completely blank." }
  const payments: VendorPaymentEntry[] = []
  for (const slot of entered) {
    const amount = parseQuestionnaireAmount(slot.paymentAmount)
    const vendorId = Number(slot.vendorId)
    if (!slot.vendorId.trim() || !Number.isInteger(vendorId) || vendorId <= 0 || amount === null || amount <= 0 || !slot.accountNumber.trim()) {
      return { error: "Each entered payment needs a vendor, account number and positive amount. Leave unused slots completely blank." }
    }
    if (payments.some((payment) => payment.vendorId === vendorId)) return { error: "Select a different vendor for each payment." }
    payments.push({ vendorId, accountNumber: slot.accountNumber.trim(), paymentAmount: amount })
  }
  return { payments }
}
